<template>
  <div>
    <div class="terms-section">
      <div class="container">
        <div class="row">
          <div class="col-lg-12">
            <h2 class="subtitle">{{ translations.complaints.complaints }}</h2>
            <div>
              <p><strong>{{ translations.complaints.privateBuyers }}</strong></p>
              <p>
                {{ translations.complaints.text1 }}
              </p>
              <p>
                {{ translations.complaints.text2 }} <strong>
                  {{ translations.complaints.emailAddress }}
                   </strong
                ><a href="mailto:webshop@eurosan.ba"><strong>webshop@eurosan.ba</strong></a
                ><strong> {{ translations.complaints.phone }} 080 080 080.</strong>
              </p>
              <p>
                {{ translations.complaints.text3 }}
              </p>
              <p>
                {{ translations.complaints.text4 }}
              </p>
              <p>
                {{ translations.complaints.text5 }}
              </p>
              <p>
                {{ translations.complaints.text6 }}
              </p>
              <p><strong>{{ translations.complaints.businessCustomers }}</strong></p>
              <p>
                {{ translations.complaints.text7 }}
              </p>
              <p>
                {{ translations.complaints.text8 }}
                <strong
                  >{{ translations.complaints.text9 }}
                  <a href="mailto:webshop@eurosan.ba">webshop@eurosan.ba.</a></strong
                >
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { translations } from '@/mixins';

export default {
  name: 'Complaints',
  mixins: [translations],
};
</script>
